module.exports = __webpack_public_path__ + "img/button_delete_highlights.89e26030.svg";